"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = render;
const vue_1 = require("vue");
const _hoisted_1 = { class: "corporations-filter-toolbox-cont" };
const _hoisted_2 = { class: "corporations-filter-toolbox corporations-filter-toolbox--topmost" };
const _hoisted_3 = ["placeholder"];
const _hoisted_4 = { class: "corporations-filter" };
const _hoisted_5 = { class: "corporations-filter-toolbox-cont" };
const _hoisted_6 = { class: "corporations-filter-toolbox" };
const _hoisted_7 = ["onClick"];
const _hoisted_8 = ["onClick"];
const _hoisted_9 = ["onClick"];
const _hoisted_10 = { class: "form-checkbox" };
const _hoisted_11 = ["value"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PopupPanel = (0, vue_1.resolveComponent)("PopupPanel");
    const _directive_i18n = (0, vue_1.resolveDirective)("i18n");
    return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_PopupPanel, {
        onClose: _cache[5] || (_cache[5] = ($event) => (_ctx.$emit('close')))
    }, {
        header: (0, vue_1.withCtx)(() => [
            (0, vue_1.createElementVNode)("div", _hoisted_1, [
                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("h2", null, [...(_cache[6] || (_cache[6] = [
                        (0, vue_1.createTextVNode)("Corporations", -1)
                    ]))])), [
                    [_directive_i18n]
                ]),
                (0, vue_1.createElementVNode)("div", _hoisted_2, [
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[0] || (_cache[0] = (0, vue_1.withModifiers)(($event) => (_ctx.selectAll('All')), ["prevent"]))
                    }, [...(_cache[7] || (_cache[7] = [
                            (0, vue_1.createTextVNode)("All*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[10] || (_cache[10] = (0, vue_1.createTextVNode)(" | ", -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[1] || (_cache[1] = (0, vue_1.withModifiers)(($event) => (_ctx.selectNone('All')), ["prevent"]))
                    }, [...(_cache[8] || (_cache[8] = [
                            (0, vue_1.createTextVNode)("None*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    _cache[11] || (_cache[11] = (0, vue_1.createTextVNode)(" | ", -1)),
                    (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                        href: "#",
                        onClick: _cache[2] || (_cache[2] = (0, vue_1.withModifiers)(($event) => (_ctx.invertSelection('All')), ["prevent"]))
                    }, [...(_cache[9] || (_cache[9] = [
                            (0, vue_1.createTextVNode)("Invert*", -1)
                        ]))])), [
                        [_directive_i18n]
                    ]),
                    (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                        ref: "filter",
                        class: "filter",
                        placeholder: _ctx.$t('filter'),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.filterText) = $event))
                    }, null, 8, _hoisted_3), [
                        [vue_1.vModelText, _ctx.filterText]
                    ])
                ])
            ])
        ]),
        default: (0, vue_1.withCtx)(() => [
            (0, vue_1.createElementVNode)("div", null, [
                (0, vue_1.createElementVNode)("div", _hoisted_4, [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.GAME_MODULES, (module) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)(vue_1.Fragment, null, [
                            (_ctx.ALL_CARDS_BY_MODULE[module].length > 0)
                                ? ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                    class: "corporations-filter-group",
                                    key: module
                                }, [
                                    (0, vue_1.createElementVNode)("div", _hoisted_5, [
                                        (0, vue_1.createElementVNode)("div", null, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(_ctx.MODULE_NAMES[module]), 1)
                                            ])), [
                                                [_directive_i18n]
                                            ]),
                                            _cache[12] || (_cache[12] = (0, vue_1.createTextVNode)(" ", -1)),
                                            (0, vue_1.createElementVNode)("div", {
                                                class: (0, vue_1.normalizeClass)(_ctx.icon(module))
                                            }, null, 2)
                                        ]),
                                        (0, vue_1.createElementVNode)("div", _hoisted_6, [
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                href: "#",
                                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.selectAll(module)), ["prevent"])
                                            }, [...(_cache[13] || (_cache[13] = [
                                                    (0, vue_1.createTextVNode)("All", -1)
                                                ]))], 8, _hoisted_7)), [
                                                [_directive_i18n]
                                            ]),
                                            _cache[16] || (_cache[16] = (0, vue_1.createTextVNode)(" | ", -1)),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                href: "#",
                                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.selectNone(module)), ["prevent"])
                                            }, [...(_cache[14] || (_cache[14] = [
                                                    (0, vue_1.createTextVNode)("None", -1)
                                                ]))], 8, _hoisted_8)), [
                                                [_directive_i18n]
                                            ]),
                                            _cache[17] || (_cache[17] = (0, vue_1.createTextVNode)(" | ", -1)),
                                            (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("a", {
                                                href: "#",
                                                onClick: (0, vue_1.withModifiers)(($event) => (_ctx.invertSelection(module)), ["prevent"])
                                            }, [...(_cache[15] || (_cache[15] = [
                                                    (0, vue_1.createTextVNode)("Invert", -1)
                                                ]))], 8, _hoisted_9)), [
                                                [_directive_i18n]
                                            ])
                                        ])
                                    ]),
                                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.ALL_CARDS_BY_MODULE[module], (corporation) => {
                                        return (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", { key: corporation }, [
                                            (0, vue_1.createElementVNode)("label", _hoisted_10, [
                                                (0, vue_1.withDirectives)((0, vue_1.createElementVNode)("input", {
                                                    type: "checkbox",
                                                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.selectedCorporations) = $event)),
                                                    value: corporation
                                                }, null, 8, _hoisted_11), [
                                                    [vue_1.vModelCheckbox, _ctx.selectedCorporations]
                                                ]),
                                                _cache[18] || (_cache[18] = (0, vue_1.createElementVNode)("i", { class: "form-icon" }, null, -1)),
                                                (0, vue_1.withDirectives)(((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("span", null, [
                                                    (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(corporation), 1)
                                                ])), [
                                                    [_directive_i18n]
                                                ]),
                                                ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.compatibility(corporation), (expansion) => {
                                                    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", {
                                                        key: expansion,
                                                        class: (0, vue_1.normalizeClass)(_ctx.icon(expansion))
                                                    }, null, 2));
                                                }), 128))
                                            ])
                                        ])), [
                                            [vue_1.vShow, _ctx.include(corporation)]
                                        ]);
                                    }), 128))
                                ]))
                                : (0, vue_1.createCommentVNode)("", true)
                        ], 64));
                    }), 256))
                ])
            ])
        ]),
        _: 1
    }));
}
